import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-upload-excel',
  template: require('./upload-excel.component.html')
})
export class UploadExcelComponent extends BaseComponent implements OnInit {

  ngOnInit() {
    super.ngOnInit();
  }

  public cancelExcel() {
    this.data = null;
    this.rawData = null;
    this.btnProcess = false;

    this.file = null;
    this.fileLogo = null;

    (document.getElementById("excelFileInput") as HTMLInputElement).value = "";
    (document.getElementById("imgLogo") as HTMLInputElement).value = "";
  }

  public data = null;
  public rawData = null;
  public btnProcess = false;


  public uploadExcel() {
    if(this.file==null) {
      bootbox.alert("Please select a excel file to upload.");
      return;
    }
    this.btnProcess = true;
    this.lsApi.uploadExcel(this.file).subscribe(resp => {

      this.btnProcess = false;
        if(resp.status) {
          this.rawData = resp.data[0];
          this.data = this.rawData.data;
        }
    },
    error => {

      this.btnProcess = false;
        console.log(error);
    });
  }

  public getManagerDetails(emp) {
    try {
      var out = "";
      emp.employeeManagersEmployee.forEach(emanager => {
        var manager = emanager;
        out += "<br><b title='" + manager.employeeId + "'>" + manager.firstname + " " + manager.lastname + "</b><br><small>" + manager.email + "</small>";
      });
      if(out.length<=0) {
        out = "No Manager";
      }
      else {
        out = out.substr(4);
      }
      return out;
    }
    catch(ex) {
      console.log(emp);
      console.log(ex);
    }
  }

  public getEmployeesCountInDept(dept) {
    var cnt = 0;
    for(var i=0;i<this.data.organization.employees.length;i++) {
      var deptName = "N/A";
      if(this.data.organization.employees[i].department!=null)
        deptName = this.data.organization.employees[i].department.name;
      else
        console.log(this.data.organization.employees[i].email)
      if(dept.name.toLowerCase()==deptName.toLowerCase()) {
        cnt++;
      }
    }
    return cnt;
  }

  public getNewEmployeesCount() {
    var cnt = 0;
    for(var i=0;i<this.data.organization.employees.length;i++) {
      var emp = this.data.organization.employees[i];
      //var deptName = this.data.organization.employees[i].department.name;
      if(emp.employeeId<=0) {
        cnt++;
      }
    }
    return cnt;
  }


  public file:any = null;
  public fileChange(event) {
      var that = this;
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {

        var ext = fileList[0].name.match(/\.([^\.]+)$/)[1];
        switch(ext.toLowerCase())
        {
            case 'xlsx':
                break;
            default:
            bootbox.alert("Excel file must be of the format .xlsx");
            return false;
        }
            
        let file: File = fileList[0];
        this.file = file;   
    }
    else {
        this.file = null;
    }
  }




  public fileLogo:any = null;
  public fileChangeLogo(event) {
      var that = this;
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {

        var ext = fileList[0].name.match(/\.([^\.]+)$/)[1];
        switch(ext.toLowerCase())
        {
            case 'jpeg':
            case 'jpg':
            case 'png':
                break;
            default:
            bootbox.alert("Logo file must be of the format .jpg, .jpeg or .png");
            return false;
        }

        
        var reader = new FileReader();
        //Read the contents of Image File.
        reader.readAsDataURL(fileList[0]);
        reader.onload = function (e:any) {
            //Initiate the JavaScript Image object.
            var image = new Image();

            //Set the Base64 string return from FileReader as source.
            
            image.src = e.target.result;
                    
            //Validate the File Height and Width.
            image.onload = function () {
                var x = this as HTMLImageElement;
                var height = x.height;
                var width = x.width;
                if ((height>200 || width > 200) || (height<=0 || width<=0)) {
                    bootbox.alert("Logo image file must be of the max resolution 200px by 200px (width x height) @ 75dpi");
                    //alert("Height and Width must be exactly 2 not exceed 100px.");
                    return false;
                }
                that.fileLogo = fileList[0];
                (document.getElementById("imgLogo") as HTMLImageElement).src = e.target.result;
                return true;
            };
        };

            
        //let file: File = fileList[0];
        //this.file = file;   
    }
    else {
        this.fileLogo = null;
    }
  }

  public processExcel() {
    this.busy = this.lsApi.processExcel(this.rawData.filename, this.fileLogo).subscribe(resp => {
        if(resp.status) {
          this.router.navigate(['/admin/organizations']).then(() => {
            this.appToast.success("Organization Successfully Saved","Organization Saved")
          })
        }
    },
    error => {

      this.btnProcess = false;
        console.log(error);
    });
  }






}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/upload-excel/upload-excel.component.ts